// extracted by mini-css-extract-plugin
module.exports = {"disableTextColor":"ApiKeyLine_disableTextColor__2sBZ4"};